import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { NgClass } from '@angular/common';

export interface StatusEvent {
    active: boolean;
}

@Component({
    selector: 'app-filter-button',
    templateUrl: './filter-button.component.html',
    styleUrls: ['./filter-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, SvgIconComponent]
})
export class FilterButtonComponent {
    @Output() statusEvent: EventEmitter<StatusEvent> = new EventEmitter();
    @Input() active: boolean = false;
    @Input() label = '';

    public onActivationEvent(): void {
        this.active = !this.active;

        this.statusEvent.emit({
            active: this.active
        });
    }
}
